import React from "react";
import classes from "./Shared.module.scss";

const phone = (props) => {
  return (
    <a className={[classes.sharedCon, classes.callLink, classes[props.where]].join(' ')} href="tel: +12516803291">251-680-3291</a>
  );
}
export default phone;